import config from '@fe-news/configs/crypto-promotion.json';
import { styled } from '@linaria/react';

const Container = styled.div`
  font-size: 18px;
  line-height: 1.7;
  padding: 16px;
  border-radius: 8px;
  border: solid 2px #e2e8f1;
  margin: 0 24px 24px;

  a {
    border-bottom: 1px solid #e03f19;
    padding: 0 3px;
    color: black;
  }

  a:hover {
    background: #e03f19;
    color: white;
  }
`;

const CryptoPromotion = () => {
  return (
    <Container>
      <p>{config.title}</p>
      <p dangerouslySetInnerHTML={{ __html: config.content }} />
      <p dangerouslySetInnerHTML={{ __html: config.link }} />
    </Container>
  );
};

export default CryptoPromotion;
